import React, { useState } from "react"
import { Box, Flex, Grid, Button } from "theme-ui"
import { useBreakpointIndex } from "@theme-ui/match-media"
import styled from "@emotion/styled"

import Logo from "components/logo"
import SearchBar from "components/navigations/searchbar"
import Nav from "components/navigations/nav"
import MobileNav from "components/navigations/mobileNav"
import Modal from "components/modal"
import ContactForm from "components/contact-form"

const Wrapper = styled.div`
    width: 100%;
    padding-top: 1rem;
    padding-bottom: 0;

    & .appointment-btn {
        text-transform: uppercase;
        border-radius: 0;
        line-height: 1em;
        font-size: 0.825rem;
        padding: 0.5rem;
        font-weight: normal;
        background: ${(props) => props.theme.colors.secondary};
        color: ${(props) => props.theme.colors.background};
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        padding: 1rem;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        padding: 0.2rem 1rem;
    }
`

const NavBar = () => {
    const breakpointIndex = useBreakpointIndex()
    const [open, setOpen] = useState(false)

    const showModal = () => {
        setOpen(true)
    }

    const hideModal = () => {
        setOpen(false)
    }
    let navbar = (
        <Grid gap={2} columns={[2, "0.2fr 2fr"]}>
            <Logo />
            <Grid gap={2}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                    }}
                >
                    <Nav sx={{ flexGrow: 2 }} />
                    <Flex>
                        <SearchBar />
                        <Button
                            sx={{ fontSize: 0 }}
                            className="appointment-btn"
                            onClick={showModal}
                        >
                            Appointment
                        </Button>
                        <Modal show={open} handleClose={hideModal}>
                            <ContactForm />
                        </Modal>
                    </Flex>
                </Box>
            </Grid>
        </Grid>
    )

    if (breakpointIndex <= 4) {
        navbar = (
            <Flex
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Logo />
                <Flex>
                    <SearchBar />
                    <MobileNav />
                </Flex>
            </Flex>
        )
    }

    return <Wrapper>{navbar}</Wrapper>
}

export default NavBar
